import apiClient, { extractData } from '../api-client';

export const ghtkApi = {
  // Kho / điểm lấy hàng GHTK
  listShops() {
    return apiClient.get('/ghtk/shops').then(extractData);
  },
  createShop(data) {
    return apiClient.post('/ghtk/shops', data).then(extractData);
  },
  updateShop(id, data) {
    return apiClient.put(`/ghtk/shops/${id}`, data).then(extractData);
  },
  deleteShop(id) {
    return apiClient.delete(`/ghtk/shops/${id}`);
  },
  setDefaultShop(id) {
    return apiClient.post(`/ghtk/shops/${id}/set-default`).then(extractData);
  },
  importShops() {
    return apiClient.post('/ghtk/import-shops').then(extractData);
  },

  parseAddress(address) {
    return apiClient.post('/ghtk/parse-address', { address }).then(extractData);
  },
  calculateFee(data) {
    return apiClient.post('/ghtk/calculate-fee', data).then(extractData);
  },
  vnProvinces() {
    return apiClient.get('/ghtk/vn-provinces').then(extractData);
  },
  vnWards(provinceCode) {
    return apiClient.get('/ghtk/vn-wards', { params: { province_code: provinceCode } }).then(extractData);
  },
  level4Address(data) {
    return apiClient.post('/ghtk/level4-address', data).then(extractData);
  },
  printLabel(label) {
    return apiClient.get(`/ghtk/print-label/${label}`, { responseType: 'blob' }).then((res) => res.data);
  },
  // Gộp nhiều nhãn GHTK thành 1 PDF (backend tải từng nhãn rồi merge bằng pypdf).
  printLabels(labels) {
    return apiClient.post('/ghtk/print-labels', { labels }, { responseType: 'blob' }).then((res) => res.data);
  },
};
